import { useEffect, useState } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { selfHireService } from '../services/selfHireService'
import { GetAllUserLinksParams } from '../services/selfHireService/getAllUserLinks'

export const useGetAllUserLinks = () => {
  const [params, setParams] = useState<GetAllUserLinksParams>({ search: '' })

  const handleGetAllUserLinksData = async ({ pageParam = 0 }) => {
    const response = await selfHireService.getAllUserLinks({
      ...params,
      skip: pageParam,
      limit: 10,
    })

    return response
  }

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isError,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ['AllUserLinks', params],
    queryFn: handleGetAllUserLinksData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit ===
        lastPage.pagination.total / lastPage.pagination.limit
      ) {
        return null
      }
      return lastPage.pagination.skip + lastPage.pagination.limit
    },
    initialPageParam: undefined,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
